import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons';
import './ThresholdRange.css';

const hasValue = value => value !== null && value !== undefined && value !== '';

export function getThresholdRangeText(lower, upper) {
    if (!hasValue(lower) && !hasValue(upper)) return '上下限未設定';
    return `上限：${hasValue(upper) ? upper : '未設定'}；下限：${hasValue(lower) ? lower : '未設定'}`;
}

export default function ThresholdRange({ lower, upper }) {
    const text = getThresholdRangeText(lower, upper);
    if (!hasValue(lower) && !hasValue(upper)) {
        return <span className="threshold-range-empty" title={text} aria-label={text}>—</span>;
    }
    return (
        <span className="threshold-range" role="img" aria-label={text} title={text}>
            {hasValue(upper) && <span className="threshold-range-bound" data-bound="upper" aria-hidden="true">
                <FontAwesomeIcon icon={faArrowUp} className="threshold-range-icon" />
                <span className="threshold-range-value">{upper}</span>
            </span>}
            {hasValue(lower) && <span className="threshold-range-bound" data-bound="lower" aria-hidden="true">
                <FontAwesomeIcon icon={faArrowDown} className="threshold-range-icon" />
                <span className="threshold-range-value">{lower}</span>
            </span>}
        </span>
    );
}
